import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). The legacy literal 'white'
// modal background maps to surfaceElevated ('#fff' — same pixel in light);
// the logo mask border must match the modal background.
const makeStyles = colors =>
  StyleSheet.create({
    centeredView: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.overlay,
    },
    modalView: {
      margin: 24,
      maxWidth: 481,
      backgroundColor: colors.surfaceElevated,
      borderRadius: 20,
      padding: 24,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
      alignItems: 'center',
    },
    buttonsContainer: {
      flexDirection: 'row',
    },
    marginBottom24: {
      marginBottom: 24,
    },
    excludedLogo: {
      width: 85,
      height: 100,
    },
    logoContainer: {
      borderColor: colors.surfaceElevated,
      borderWidth: 16,
      position: 'relative',
      top: -58,
      left: 0,
    },
    animatedCircularProgress: {
      position: 'relative',
      top: 58,
      left: 0,
    },
    textStyle: {
      textAlign: 'center',
      marginBottom: 8,
    },
  });

export default makeStyles;
